/**
 * @license Givaudan. All rights reserved
 * @author Ayoub MHAMDI
 */

import { Cart, CartV2 } from '../models/cart/cart.model';
import { CartResponse, CartResponseV2 } from '../models/cart/cart-response.model';

export function fromCartResponseToCart(cartResponse: CartResponse): Cart {
  return {
    id: cartResponse.id,
    currency: {
      code: cartResponse.currency.code,
    },
    taxIncluded: cartResponse.taxIncluded,
    baseAmount: cartResponse.baseAmount,
    discountAmount: cartResponse.discountAmount,
    cartAmount: cartResponse.cartAmount,
    lineItems: cartResponse.lineItems.physicalItems,
    quoteId: cartResponse.quoteId,
  };
}

export function fromCartResponseToCartV2(cartResponse: CartResponseV2): CartV2 {
  return {
    id: cartResponse.id,
    currency: {
      code: cartResponse.currency.code,
    },
    taxIncluded: cartResponse.taxIncluded,
    baseAmount: cartResponse.baseAmount,
    discountAmount: cartResponse.discountAmount,
    cartAmount: cartResponse.cartAmount,
    lineItems: cartResponse.lineItems.physicalItems,
    requestId: cartResponse.requestId,
  };
}